import {
  InfiniteApplicationStatus,
  InfiniteApplicationSummary,
  ListInfiniteApplicationsResponse,
  listInfiniteApplications,
} from '~/services/LuxLoyalty';

export const INFINITE_APPLICATIONS_FETCH_PAGE_SIZE = 100;

type ListInfiniteApplicationsFilters = {
  status?: InfiniteApplicationStatus;
  email?: string;
};

export async function collectInfiniteApplicationPages(
  fetchPage: (page: number, pageSize: number) => Promise<ListInfiniteApplicationsResponse>,
  pageSize = INFINITE_APPLICATIONS_FETCH_PAGE_SIZE,
): Promise<Array<InfiniteApplicationSummary>> {
  const applications: Array<InfiniteApplicationSummary> = [];
  let page = 1;

  while (true) {
    const response = await fetchPage(page, pageSize);
    const pageRows = response.result.applications ?? [];
    applications.push(...pageRows);

    const pageCount = response.result.pageInfo?.pageCount ?? page;
    const totalRecords = response.result.pageInfo?.totalRecords ?? applications.length;
    if (
      pageRows.length === 0 ||
      pageRows.length < pageSize ||
      page >= pageCount ||
      applications.length >= totalRecords
    ) {
      return applications;
    }

    page += 1;
  }
}

export async function listAllInfiniteApplications(
  params: ListInfiniteApplicationsFilters = {},
): Promise<Array<InfiniteApplicationSummary>> {
  return collectInfiniteApplicationPages((page, pageSize) =>
    listInfiniteApplications({
      ...params,
      page,
      pageSize,
    }),
  );
}
